import { memo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import useStatusTagStyles from '../../../styles/useStatusTagStyles';
import clsx from 'clsx';

export enum Status {
  InProgress = 'In Progress',
  OnHold = 'On Hold',
  Complete = 'Complete',
  Request = 'Request',
  LeadOnly = 'Lead Only',
}

const StatusTag = memo(function StatusTag(props: { label: string }) {
  const { label } = props;
  const classes = useStatusTagStyles();
  let statusLabel = '';
  if (label === 'In Progress') {
    statusLabel = Status.InProgress;
  } else if (label === 'On Hold') {
    statusLabel = Status.OnHold;
  } else if (label === 'Complete') {
    statusLabel = Status.Complete;
  } else if (label === 'Request') {
    statusLabel = Status.Request;
  } else {
    statusLabel = Status.LeadOnly;
  }

  return <div className={clsx(classes.tag, label.replace(/ /g, ''))}>{statusLabel}</div>;
});

export function renderStatus(params: ICellRendererParams) {
  return <StatusTag label={params.data.status} />;
}
